// @ts-nocheck

import { makeStyles } from '@material-ui/core/styles'

/**
 * Material UI framework styling object
 * @type {StylesHook<Styles<Theme, {}, string>>}
 */
const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(0),
    maxWidth: '100%',
    height: '100vh',
  },
  form: {
    width: '100%',
    marginTop: theme.spacing(2),
  },
  authForm: {
    width: '550px',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
  },
  signUpStepper: {
    width: '800px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  signUpBody: {
    padding: theme.spacing(0),
    '&#parent-info-wrapper': {
      width: '100%',
    },
    '& .custom-info-button.MuiButton-contained:not(.Mui-disabled)': {
      'body[data-theme="EHS"] &': {
        backgroundColor: '#1976D2',
        '&:hover': {
          backgroundColor: '#2196F3',
        },
      },
    },
  },
  formRegister: {
    width: '100%',
  },
  accountInfo: {
    width: '400px',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
  },
  studentInfo: {
    width: '750px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  rejectedInfo: {
    width: '750px',
    margin: 'auto',
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  selectIcon: {
    '& .MuiSelect-iconOutlined': {
      right: '44px',
    },
  },
  quilDesign: {
    '& .ql-container ': {
      borderBottomLeftRadius: '0.5em',
      borderBottomRightRadius: '0.5em',
      background: '#fff',
    },
    '& .ql-snow.ql-toolbar': {
      background: '#eaecec',
      borderTopLeftRadius: '0.5em',
      borderTopRightRadius: '0.5em',
    },
    '& .ql-editor': {
      minHeight: '18em',
    },
  },
}))

export default useStyles
